import React, { useState, useEffect } from 'react'

import { DEI_COLORS } from "../constants"

import DEIPageBarChartBar from './DEIPageBarChartBar/DEIPageBarChartBar'

import {
  DEIPageBarChartDIV,
  DEIPageBarChartTitleDIV,
  DEIPageBarChartChartDIV,
} from './DEIPageBarChart.styles'

const COLORS = [
  DEI_COLORS.BLUE,
  DEI_COLORS.YELLOW,
  DEI_COLORS.PINK,
  DEI_COLORS.LIGHT_BLUE,
  DEI_COLORS.INDIGO,
  DEI_COLORS.PURPLE,
]

const LAST_COLOR = DEI_COLORS.NEUTRAL

const DEIPageBarChart = ({ data }) => {
  const [activeDateIndex, setActiveDateIndex] = useState(0)

  // Reset when the data changes
  useEffect(() => {
    setActiveDateIndex(0)
  }, [data])

  const percentages = data.dates[activeDateIndex] ? data.dates[activeDateIndex].percentages : data.dates[0].percentages

  return (
    <DEIPageBarChartDIV>
      <DEIPageBarChartTitleDIV>
        <select
          className="size--M"
          onChange={e => setActiveDateIndex(e.target.value)}
          value={activeDateIndex}
        >
          {data.dates.map(({ title }, i) => (
            <option
              key={title}
              value={i}
            >
              {title}
            </option>
          ))}
        </select>
        <h3>{data.title}</h3>
      </DEIPageBarChartTitleDIV>
      <DEIPageBarChartChartDIV>
        {percentages.map(({ title, percentage }, i) => {
          const isLast = percentages.length - 1 === i
          const width = 100 / percentages.length

          return (
            <DEIPageBarChartBar
              key={isLast ? 'last' : i}
              color={isLast ? LAST_COLOR : COLORS[i]}
              percentage={percentage}
              title={title}
              width={width}
            />
          )
        })}
      </DEIPageBarChartChartDIV>
    </DEIPageBarChartDIV>
  )
}

export default DEIPageBarChart
